module.exports = __webpack_public_path__ + "static/img/business.774e0ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/business.png
// module id = TUVP
// module chunks = 1